import React from 'react'
import { Navigate, useLocation } from 'react-router-dom';
const AuthCheck = (Component) => {
    const AuthComponent = (props) => {
        const location = useLocation();
        const isAuthenticated = localStorage.getItem('token');
    
        if (isAuthenticated && location.pathname === '/signin') {
          return <Navigate to="/" />;
        }

        if(location.pathname === '/signin'){
          document.title = 'Admin - Sign In'
        }
    
        // Render the protected component if authenticated
        return <Component {...props} />;
      };
      return AuthComponent
}

export default AuthCheck
